<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    [isConfigured]="isConfigured"
    (onIntegrate)="onIntegrate($event)"
    [description]="widgetRef.widgetDescription"
></app-integration>
